// import { faFacebook, faGoogle } from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faLock,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
//import Logo from "../../../images/logo.png";
import { Link, useNavigate ,Navigate} from "react-router-dom";
import SocialLogin from "../SocialLogin/SocialLogin";
import { useTranslation } from "react-i18next";
import { legalDisclaimerApi, login, sendotp } from "../../../api/user";
import { toast } from "react-toastify";
import PageContainer from "../../../components/pages/PageContainer";
import Loader from "../../../components/Loader";
import { event } from "../../../utils/event";
import LegalPopupModal from "../../../components/Modals/legalDisclaimer";
function LoginIndex() {
  //const { t, i18n } = useTranslation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPopup, setShowPopUp] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  const handleCheckboxChange1 = () => {
    setChecked(!checked);
  };

  const handleClose = () => {
    navigate("/profile");
    localStorage.setItem("checkDisclaimer", false);
    return setShowPopUp(false);
  };

  const handleLegalPopup = async () => {
    if (!checked) {
      toast.error("Please accept our legal policies.");
      return;
    }
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    try {
      const res = await legalDisclaimerApi(checked);
      if (res?.data?.status === 200) {
        setShowPopUp(false);
        if (userInfo?.user_name) {
          navigate("/profile");
        } else {
          navigate("/edit-profile");
        }
        localStorage.setItem("checkDisclaimer", false);
      }
    } catch (err) {}
  };

  useEffect(() => {
    event("sendDataToReactApp");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic email validation
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError({ email: ["Invalid email address"] });
      return;
    }

    // Password validation
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*[a-z]).{8,}$/;
    if (!password || !passwordRegex.test(password)) {
      setError({
        password: [
          'Password must be at least 8 characters and include one capital letter and one special character (!@#$%^&*(),.?":{}|<>)',
        ],
      });
      return;
    }

    setError(null);
    setLoading(true);

    const body = {
      username: email,
      password: password,
    };

    try {
      const response = await login(body);
      if (response?.data?.status === 200) {
        if (response?.data?.data?.disclaimer === false) {
          setShowPopUp(true);
        }else {
  // Retrieve gameurl from local storage
  let savedUrl = JSON.parse(localStorage.getItem("gameurl"));

   const redirectUrl = localStorage.getItem("redirectUrl") || "/";
    localStorage.removeItem("redirectUrl");

  // Replace "contests" with "contest" in the saved URL if it exists
  if (savedUrl && savedUrl.includes("/contests/")) {
    savedUrl = savedUrl.replace("/contests/", "/contest/");
  }

  // Redirect to the saved URL if it exists, otherwise go to /profile
  if (savedUrl) {
    window.location.href = savedUrl;
  } else if(redirectUrl){
    window.location.href = redirectUrl;
  }
   else {
    navigate("/profile");
  }
}
        const accessToken = response.data.data.access_token;
        localStorage.setItem("accessToken", JSON.stringify(accessToken));
        localStorage.setItem(
          "messageCount",
          response?.data?.data?.message_count
        );
        localStorage.setItem("notificationCount", response?.data?.data?.badge);
        localStorage.setItem("userEmail", response.data.data.email);
        localStorage.setItem("userInfo", JSON.stringify(response.data.data));
        localStorage.setItem("isVerified", response.data.data?.is_otp_verified);
        localStorage.setItem("img", response.data.data.image);
        localStorage.setItem("user_id", response.data.data.id);
        const email = { email: response.data.data.email, otp_purpose: 2 };
        const is_otp_verified = JSON.parse(response.data.data?.is_otp_verified);
        if (!is_otp_verified) {
          const res = await sendotp(email);
          if (res) {
            if (res.data.status === 400) {
              toast.error(res.data.message);
              navigate("/auth/verification")
              // <Navigate to="/auth/verification" />
            } else {
              toast.error("Your account is not verified yet!");
              toast.success(res.data.message);
            }
            setLoading(false);
            localStorage.setItem("email_token", res.data.data.email_token);
          }
          setLoading(false);
          navigate("/auth/verification");
        } else {
          setLoading(false);
          if (response?.data?.data?.disclaimer === false) {
            setShowPopUp(true);
          } else {
            setTimeout(() => {
              navigate("/profile");
            }, 2000);
          }
        }
      }
      setLoading(false);
      if (response?.data?.status === 400) {
        toast.error(response.data.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <>
      <PageContainer>
        <div className="flex min-h-screen">
  <div className="flex justify-center w-full flex-col md:flex-row">

    {/* Left Side — Branding / Logo Section */}
    <div className="md:bg-primaryColor md:min-h-screen flex flex-wrap md:w-1/2">
{!isMobileView && (
  <div className="items-center text-center flex flex-col relative justify-center mx-auto mt-2">
    <img
      src={"/qushi_logo.png"}
      alt="Logo Login"
      className="md:w-48 w-48 mx-auto"
    />
  </div>
)}

    </div>
            {/* Login Section */}
            <div className="flex flex-col md:w-1/2 items-center justify-center">
              <div className="w-full  loginWrapper flex flex-col lg:w-3/5 max-w-md lg:px-10 md:px-5 px-5 pt-2">
                {/* Login Header Text */}
                <div className="text-center flex flex-col justify-center mx-auto relative">
                  <img
                    src={"/qushi_logo.png"}
                    alt="Logo Login"
                    className="md:w-32 mt-4 w-32 mx-auto"
                  />
                </div>

                <div className="mt-1  md:block font-medium self-center text-xl sm:text-3xl text-gray-800">
                  Sign In
                </div>
                <div className="mt-3 h-px bg-gray-300"></div>

                {/* Login Form */}
                <div className="mt-3 login-screen">
                  <form onSubmit={handleSubmit}>
                    {/* Username */}
                    <div className="flex flex-col mb-2">
                      <label className="text-xs mb-1 text-gray-400">
                        {t("Email Address")}
                      </label>
                      <div className="relative">
                        <div className="inline-flex items-center justify-center absolute left-0 top-0 h-7 w-8 text-gray-400 mt-1 sm:mt-1">
                          <FontAwesomeIcon icon={faEnvelope} />
                        </div>
                        <input
                          id="email"
                          type="text"
                          name="email"
                          style={{
                            paddingLeft: "28px",
                          }}
                          onChange={(e) => setEmail(e.target.value)}
                          className="text-sm placeholder-gray-500 pl-8 pr-3 rounded-lg border border-gray-400 w-full px-2 py-2 focus:outline-none focus:border-emerald-400"
                          placeholder=""
                        />
                      </div>
                      {error?.email && (
                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                          {error.email[0]}
                        </span>
                      )}
                    </div>

                    {/* Password */}
                    <div className="flex flex-col mb-4">
                      <label className="text-xs mb-1 text-gray-400">
                        {"password"}
                      </label>
                      <div className="relative">
                        <div className="inline-flex items-center justify-center absolute left-0 top-0 h-7 w-8 text-gray-400 mt-1 sm:mt-1">
                          <FontAwesomeIcon icon={faLock} />
                        </div>
                        <input
                          id="password"
                          type={showPassword ? "text" : "password"}
                          name="password"
                          style={{
                            paddingLeft: "28px",
                          }}
                          onChange={(e) => setPassword(e.target.value)}
                          className="text-sm placeholder-gray-500 pl-8 pr-3 rounded-lg border border-gray-400 w-full px-2 py-2 focus:outline-none focus:border-emerald-400"
                          placeholder=""
                        />
                        <div
                          className="inline-flex items-center justify-center absolute right-0 top-0 h-7 w-8 text-gray-400 cursor-pointer mt-1 sm:mt-1"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <FontAwesomeIcon icon={faEyeSlash} />
                          ) : (
                            <FontAwesomeIcon icon={faEye} />
                          )}
                        </div>
                      </div>
                      {error?.password && (
                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                          {error.password[0]}
                        </span>
                      )}
                    </div>

                    {/* Forgot Password Link */}
                    <div className="flex items-center mb-3">
                      <div className="ml-auto">
                        <Link
                          to="/auth/forgot-password"
                          className="font-semibold text-xs sm:text-sm text-gray-400 hover:text-primaryColor underline"
                        >
                          {t("forgot_your_password")}?
                        </Link>
                      </div>
                    </div>

                    {/* Button Login */}
                    <div className="flex w-full">
                      <button
                        disabled={loading}
                        type="submit"
                        className="flex items-center justify-center focus:outline-none text-white text-sm bg-primaryColor rounded-lg py-3 w-full"
                      >
                        <span className="mr-2 uppercase">
                          {loading ? t("processing") + "...." : t("sign_in")}
                        </span>
                      </button>
                    </div>
                  </form>
                </div>

                {/* Social Button */}
                <SocialLogin />
                {/* End Social Button */}

                {/* Register Link */}
                <div className="flex flex-col justify-center items-center mt-4">
                  <p className="text-gray-400">{t("new_user")}?</p>
                  <Link
                    to="/auth/register"
                    className="inline-flex w-full items-center mt-2 rounded-xl text-center"
                  >
                    <button
                      disabled={loading}
                      type="submit"
                      className="flex items-center justify-center focus:outline-none text-primaryColor text-sm border-2 border-primaryColor rounded-xl py-2 w-full"
                    >
                      <span className="mr-2 uppercase text-sm font-semibold">
                        {loading
                          ? t("processing") + "...."
                          : t("create_account")}
                      </span>
                    </button>
                  </Link>
                </div>
                {/* End Register Link */}
              </div>
            </div>

          </div>
        </div>

        {loading ? <Loader /> : ""}
        <LegalPopupModal
          isOpen={showPopup}
          handleLegalPopup={handleLegalPopup}
          checked={checked}
          handleClose={handleClose}
          handleCheckboxChange1={handleCheckboxChange1}
        />
      </PageContainer>
    </>
  );
}

export default LoginIndex;
